import router from '@/router/'
export const routerBack = () => {
    window.history.length > 1 ? router.go(-1) : router.push('/')
}